import React from 'react';
import {RoutePermittedRole} from 'shared/constants/AppConst';

const FuelPrice = React.lazy(() => import('./FuelPrice'));
export const FuelPriceConfig = [
  {
    permittedRole: RoutePermittedRole.superAdmin,
    path: '/fuel-price',
    element: <FuelPrice />,
  },
];

const CorporateFuelPrice = React.lazy(() => import('./CorporateFuelPrice'));
export const CorporateFuelPriceConfig = [
  {
    permittedRole: RoutePermittedRole.ALL,
    path: '/master/corporate-fuel-price',
    element: <CorporateFuelPrice />,
  },
];
